<template>
  <hm-content title="">
    <div class="add-goods-container act-container">
      <hm-step
        :steps="steps"
        :scroll="true"
        :step="currentStep"
        @scroll="windowScroll"
      ></hm-step>
      <!-- <el-scrollbar :style="{ height: scrollHeight + 'px' }"> -->
      <div class="pvw flex flex-warp">
        <div class="flex-4">
          <el-form
            style="flex: 4;"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="product-ruleForm"
          >
            <div id="base">1.基本信息</div>
            <el-form-item label="活动标题" prop="gameName">
              <el-input
                maxlength="25"
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.gameName"
                placeholder="请输入活动标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动时间段选择" prop="activityDate">
              <el-date-picker
                :disabled="ruleForm.updateMode === 'no'"
                :default-time="['00:00:00', '23:59:59']"
                v-model="ruleForm.activityDate"
                type="datetimerange"
                align="right"
                :picker-options="pickerOptions"
                start-placeholder="活动开始时间"
                end-placeholder="活动结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="活动分享文案" prop="gameShareContent">
              <el-input
                :maxlength="30"
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.gameShareContent"
                placeholder="请输入活动分享文案，30字以内"
              ></el-input>
            </el-form-item>
            <el-form-item label="背景音乐链接" prop="gameBgm">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model="ruleForm.gameBgm"
                placeholder="请输入音乐链接/音乐网络地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传背景图" prop="mainImgUrl">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                v-if="show"
                noCircle
                noSquare
                :width="750"
                :height="1334"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <!-- <el-button
                  type="primary"
                  size="small"
                  v-show="!listHeaderImgUrl"
                  @click="toggleShow"
                  >上传</el-button
                > -->
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShow"
                  v-if="!listHeaderImgUrl"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>上传活动背景图</span>
                </div>
                <div v-if="listHeaderImgUrl" class="priview mr10 flex item-end">
                  <img :src="listHeaderImgUrl" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemoveGameBgp"
                      >删除</el-button
                    >
                  </div>
                </div>
              </div>
              <span class="form-tip">图片尺寸建议750x1334（最多上传一张）</span>
              <!-- <div class="priview" v-if="listHeaderImgUrl">
                  <img :src="listHeaderImgUrl" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemove"
                      >删除</el-button
                    >
                  </div>
                </div> -->
            </el-form-item>

            <el-form-item label="上传转盘图" prop="gameBgp2">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccessBgp2"
                @crop-upload-fail="cropUploadFail"
                v-model="showgameBgp2"
                v-if="showgameBgp2"
                noCircle
                noSquare
                :width="642"
                :height="642"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>

              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShowgameBgp2"
                  v-if="!gameBgp2"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>上传转盘图</span>
                </div>
                <div v-if="gameBgp2" class="priviewbgp2 mr10 flex item-end">
                  <img :src="gameBgp2" alt="转盘图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemoveGameBgp2"
                      >删除</el-button
                    >
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="上传转盘指针图" prop="gameBgp3">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccessBgp3"
                @crop-upload-fail="cropUploadFail"
                v-model="showgameBgp3"
                v-if="showgameBgp3"
                noCircle
                noSquare
                :width="150"
                :height="160"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShowgameBgp3"
                  v-if="!gameBgp3"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>上传转盘指针图</span>
                </div>
                <div v-if="gameBgp3" class="priviewbgp3 mr10 flex item-end">
                  <img :src="gameBgp3" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemoveBgp3"
                      >删除</el-button
                    >
                  </div>
                </div>
              </div>
              <!-- <span class="form-tip"
                  >图片尺寸建议750x1334（最多上传一张）</span
                > -->
            </el-form-item>

            <el-form-item label="活动规则说明" prop="gameRuleRemark">
              <hm-rich-editor
                v-model="ruleForm.gameRuleRemark"
                :html="ruleForm.gameRuleRemark"
              />
            </el-form-item>

            <el-form-item label="虚拟参与人数" prop="visualJoinNum">
              <span>在实际参与人数基础上增加</span
              ><el-input
                type="number"
                @mousewheel.prevent.native
                style="width: 100px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.visualJoinNum"
                placeholder="请输入数字"
              ></el-input
              >人
              <div class="form-tip">
                显示在手机端，已参与活动人数=实际参与人数加上此处设置的虚拟人数
              </div>
            </el-form-item>
            <div id="gameRule">{{ steps.length === 3 ? 2 : 2 }}活动规则</div>

            <el-form-item label="抽奖限制" prop="drawType">
              <template>
                <div>
                  <el-radio
                    :disabled="ruleForm.updateMode === 'no'"
                    v-model="rule.drawType"
                    label="total"
                  >
                    <span>总抽奖限制,限制活动时间,每人最多抽奖</span>
                    <el-input
                      type="number"
                      @mousewheel.prevent.native
                      :disabled="
                        this.rule.drawType !== 'total' ||
                          ruleForm.updateMode === 'no'
                      "
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model="rule.drawPrizeNumTotal"
                      placeholder="请输入数字"
                    ></el-input>
                    <span>次,每人中奖上限</span>
                    <el-input
                      type="number"
                      @mousewheel.prevent.native
                      :disabled="
                        this.rule.drawType !== 'total' ||
                          ruleForm.updateMode === 'no'
                      "
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.eachWinningUpperLimitTotal"
                      placeholder="请输入数字"
                    ></el-input>
                  </el-radio>
                </div>
                <div>
                  <el-radio
                    v-model="rule.drawType"
                    :disabled="ruleForm.updateMode === 'no'"
                    label="daily"
                  >
                    <span>每日抽奖限制,每人每日抽奖</span>
                    <el-input
                      type="number"
                      @mousewheel.prevent.native
                      :disabled="this.rule.drawType !== 'daily'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.drawPrizeNumDaily"
                      placeholder="请输入数字"
                    ></el-input>
                    <span>次,每人中奖上限</span>
                    <el-input
                      type="number"
                      @mousewheel.prevent.native
                      :disabled="this.rule.drawType !== 'daily'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.eachWinningUpperLimitDaily"
                      placeholder="请输入数字"
                    ></el-input>
                  </el-radio>
                </div>
                <div class="form-tip">
                  达到抽奖上限次数将不能参加抽奖，达到中奖上限将不再获得奖品
                </div>
              </template>
            </el-form-item>
            <el-form-item label="活动奖品设置" prop="drawTypeList">
              <div
                class="form-tips"
                style="color: #e50163; font-size: 12px"
                v-if="wheelType === 'grid'"
              >
                九宫格转盘只能添加7个商品，少于7个商品的部分在小程序将被谢谢惠顾填充
              </div>
              <el-table
                :data="rule.turntablePrizeRuleList"
                style="width: 100%"
                ref="table"
                border
                stripe
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖项"
                  prop="rankingSeqNum"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        :disabled="ruleForm.updateMode === 'no'"
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        v-model.trim="scope.row.rankingSeqNum"
                        placeholder="请输入奖项"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品类型"
                  prop="prizeType"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-select
                        :disabled="ruleForm.updateMode === 'no'"
                        clearable
                        size="small"
                        style="width:100%"
                        v-model="scope.row.prizeType"
                        placeholder="请选择奖品类型"
                      >
                        <el-option label="积分" value="1"></el-option>
                        <el-option label="优惠劵" value="2"></el-option>
                        <el-option label="实物" value="3"></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品内容"
                  prop="prizeType"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        :disabled="ruleForm.updateMode === 'no'"
                        type="number"
                        @mousewheel.prevent.native
                        v-if="scope.row.prizeType == '1'"
                        style="width:100%"
                        v-model.trim="scope.row.typeValue"
                        @input="filterGt0OrFixed('typeValue', scope.$index)"
                        size="small"
                        clearable
                        placeholder="奖品积分"
                      ></el-input>
                      <el-input
                        :disabled="ruleForm.updateMode === 'no'"
                        v-if="scope.row.prizeType == '3'"
                        style="width:100"
                        v-model.trim="scope.row.typeValue"
                        size="small"
                        clearable
                        placeholder="实物名称"
                      ></el-input>
                      <el-select
                        :disabled="ruleForm.updateMode === 'no'"
                        v-if="scope.row.prizeType == '2'"
                        clearable
                        size="small"
                        style="width:100"
                        v-model="scope.row.typeValue"
                        placeholder="请选择优惠券"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.couponSendId"
                          v-for="(item, i) in couponList"
                          :key="i"
                        ></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品名称"
                  prop="prizeName"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        :disabled="ruleForm.updateMode === 'no'"
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        v-model.trim="scope.row.prizeName"
                        placeholder="奖品名称"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品图片"
                  prop="prizeName"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <div
                        class="flex goods-upload-btn"
                        @click="addGoodsImg(scope.row, 'prizeImg')"
                        v-if="!scope.row.prizeImg"
                      >
                        <div
                          style="margin-left:0px"
                          class="btn flex flex-column flex-center open-file item-center"
                        >
                          <div class="add-prize-img-wrapper">
                            <span class="hmicon icon-hao pointer"></span>
                          </div>
                          <span>添加图片</span>
                        </div>
                      </div>
                      <div v-else class="mr10 flex item-end priviews">
                        <!-- <img class="logo" :src="scope.row.prizeImg" alt="logo" /> -->
                        <el-image
                          class="img"
                          :src="scope.row.prizeImg"
                          alt="logo"
                          :preview-src-list="[scope.row.prizeImg]"
                        />
                        <div
                          class="opreat-wrapper flex item-center flex-center"
                        >
                          <el-button
                            type="text"
                            @click="handleRemove(scope.$index)"
                            >删除</el-button
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品数量"
                  prop="prizeNum"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        :disabled="ruleForm.updateMode === 'no'"
                        size="small"
                        clearable
                        class=" ipt"
                        maxlength="60"
                        style="width:100%"
                        v-model.trim="scope.row.prizeNum"
                        placeholder="请输入数量"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="单人中奖上限"
                  prop="eachPrizeWinningUpperLimit"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        @input="filterGt0OrFixed22(scope.$index, 'eachPrizeWinningUpperLimit')"
                        v-model.trim="scope.row.eachPrizeWinningUpperLimit"
                        placeholder="请输入单人中奖上限"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="winningRate"
                >
                  <template slot="header">
                    <span class="mr10">中奖率</span>
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover"
                    >
                      <div>
                        中奖率合计不能超过100%
                      </div>
                      <span slot="reference">
                        <i class="el-icon-question" style="fontSize:20px"></i>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <div class="flex item-center p10">
                      <el-input
                        :disabled="ruleForm.updateMode === 'no'"
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="18"
                        style="width:100%"
                        @input="filterGt0OrFixed22(scope.$index, 'winningRate')"
                        v-model.trim="scope.row.winningRate"
                        placeholder="中奖率"
                      ></el-input
                      >%
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="出奖门槛（总抽奖数到达多少次）"
                  prop="awardThreshold"
                >
                  <template slot-scope="scope">
                    <div class="flex item-center p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="18"
                        style="width:100%"
                        :disabled="ruleForm.updateMode === 'no'"
                        @input="
                          filterGt0OrFixed0(scope.$index, 'awardThreshold')
                        "
                        v-model.trim="scope.row.awardThreshold"
                        placeholder="请输入数字"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderSn"
                  label="操作"
                  width="80px"
                  v-show="ruleForm.updateMode === 'yes'"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <div
                        style="margin-left:0px"
                        class="add-wrapper flex flex-center"
                        v-if="scope.$index === 0"
                      >
                        <span
                          class="hmicon icon-hao pointer"
                          @click="addChild(scope.$index)"
                        ></span>
                      </div>
                      <div
                        style="margin-left:0px"
                        class="minus-wrapper flex flex-center"
                        v-else
                      >
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deleteChild(scope.$index)"
                        ></span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div class="table game-select">
                  <div class="table-header flex">
                    <div class="flex-1 text-center">奖项</div>
                    <div class="flex-1 text-center">奖品类型</div>
                    <div class="flex-1 text-center">奖品内容</div>
                    <div class="flex-1 text-center">奖品名称</div>
                    <div class="flex-1 text-center">奖品图片</div>
                    <div class="flex-1 text-center">奖品数量</div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="数字越小，代表优先级越高，则优先出此奖项。如，一等奖优先级为3，二等奖优先级为2,三等奖优先级为1,则先出三等奖，再出二等奖，最后出一等奖"
                      placement="top"
                    >
                      <div class="flex-1 text-center primary">优先级</div>
                    </el-tooltip>
                    <div
                      class="flex-1 text-center"
                      v-show="ruleForm.updateMode === 'yes'"
                    >
                      操作
                    </div>
                  </div>
                  <div class="table-body">
                    <div
                      class="flex table-row item-center"
                      v-for="(item, index) in rule.turntablePrizeRuleList"
                      :key="index"
                    >
                      <div class="flex-1 text-center">
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          style="width:100px"
                          v-model.trim="item.rankingSeqNum"
                          size="small"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-select
                          :disabled="ruleForm.updateMode === 'no'"
                          clearable
                          class="mr10 "
                          size="small"
                          v-model="item.prizeType"
                          placeholder="请选择奖品类型"
                        >
                          <el-option label="积分" value="1"></el-option>
                          <el-option label="优惠劵" value="2"></el-option>
                          <el-option label="实物" value="3"></el-option>
                        </el-select>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          @mousewheel.prevent.native
                          v-if="item.prizeType == '1'"
                          style="width:140px"
                          v-model.trim="item.typeValue"
                          size="small"
                          clearable
                          @input="filterGt0OrFixed('typeValue', index)"
                          placeholder="请输入奖品积分"
                        ></el-input>
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          v-if="item.prizeType == '3'"
                          style="width:140px"
                          v-model.trim="item.typeValue"
                          size="small"
                          clearable
                          placeholder="请输入奖品实物名称"
                        ></el-input>
                        <el-select
                          :disabled="ruleForm.updateMode === 'no'"
                          v-if="item.prizeType == '2'"
                          clearable
                          size="small"
                          v-model="item.typeValue"
                          placeholder="请选择优惠券"
                        >
                          <el-option
                            :label="item.name"
                            :value="item.couponSendId"
                            v-for="(item, i) in couponList"
                            :key="i"
                          ></el-option>
                          
                        </el-select>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          style="width:140px"
                          v-model.trim="item.prizeName"
                          size="small"
                          clearable
                          placeholder="请输入奖品名称"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center flex flex-center item-center">
                        <div class="flex goods-upload-btn" @click="addGoodsImg(item, 'prizeImg')">
                          <div
                            class="btn flex flex-column flex-center open-file item-center"
                            v-if="!item.prizeImg"
                          >
                            <div class="add-prize-img-wrapper">
                              <span class="hmicon icon-hao pointer"></span>
                            </div>
                            <span>添加图片</span>
                          </div>
                          <div v-if="item.prizeImg" class="mr10 flex item-end">
                            <img class="logo" :src="item.prizeImg" alt="logo" />
                          </div>
                        </div>
                        <my-upload
                          field="file"
                          @crop-success="cropSuccess"
                          @crop-upload-success="cropUploadSuccess"
                          @crop-upload-fail="cropUploadFail"
                          v-model="showPrizeImg"
                          noCircle
                          noSquare
                          :width="100"
                          :height="100"
                          :headers="{ 'X-Access-Token': $token }"
                          :params="{ fileDir: 'goodsCenter' }"
                          :url="$uploadUrl"
                          img-format="png"
                        ></my-upload>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          @mousewheel.prevent.native
                          style="width:100px"
                          @input="filterGt0OrFixed('prizeNum', index)"
                          v-model.trim="item.prizeNum"
                          size="small"
                          placeholder="请输入数量"
                        ></el-input>
                      </div>

                      <div class="flex-1 text-center">
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          @mousewheel.prevent.native
                          style="width:100px"
                          v-model.trim="item.prizePriority"
                          size="small"
                          @input="filterGt0OrFixed('prizePriority', index)"
                          placeholder="请输入数字"
                        ></el-input>
                      </div>
                      <div
                        class="flex-1"
                        v-show="ruleForm.updateMode === 'yes'"
                      >
                        <div
                          class="add-wrapper flex flex-center"
                          v-if="index === 0"
                        >
                          <span
                            class="hmicon icon-hao pointer"
                            @click="addChild(index)"
                          ></span>
                        </div>
                        <div class="minus-wrapper flex flex-center" v-else>
                          <span
                            class="hmicon icon-jianhao pointer"
                            @click="deleteChild(index)"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
            </el-form-item>
            <el-form-item label="预计参与次数" prop="estimatedNum"
              ><el-input
                :disabled="ruleForm.updateMode === 'no'"
                type="number"
                @mousewheel.prevent.native
                @input="filterGt0OrFixed2('estimatedNum')"
                style="width: 100px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="rule.estimatedNum"
                placeholder="请输入次数"
              ></el-input
              >次
              <div class="form-tip">
                预计参与次数，将直接影响中奖概率，中奖概率=奖品数量/(奖品数量总和+预计参与次数)
              </div>
            </el-form-item>
            <div id="gameAstrict">{{ steps.length === 3 ? 3 : 3 }}活动限制</div>
            <el-form-item label="活动参与门槛" prop="eachConsumIntegral">
              <span>每次消耗积分</span
              ><el-input
                :disabled="ruleForm.updateMode === 'no'"
                type="number"
                @mousewheel.prevent.native
                @input="filterGt0OrFixed3('eachConsumIntegral')"
                style="width: 130px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="threshold.eachConsumIntegral"
                placeholder="请输入积分数值"
              ></el-input>
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                @click="submitForm('ruleForm')"
                >发布</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </div>
        <!-- <div class="text-center flex-1">
            <el-button
              class="fixed-but"
              size="small"
              type="danger"
              round
              @click="minimum"
              v-if="isCollapse"
            >
              <span class="hmicon icon-shouji"></span>
              <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
              <span class="hmicon icon-youshuangjiantou arrow"></span>
            </el-button>
            <el-button
              v-else
              class="fixed-but"
              size="small"
              type="primary"
              round
              @click="minimum"
            >
              <span class="hmicon icon-shouji"></span>
              <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
              <span class="hmicon icon-youshuangjiantou arrow"></span>
            </el-button>
          </div> -->
        <div
          v-show="!isCollapse"
          class="pvws"
          :style="{ backgroundImage: 'url(' + listHeaderImgUrl || +')' }"
        >
          <div id="audio_btn" @click="bgm">
            <audio
              :src="ruleForm.gameBgm"
              autoplay="true"
              loop="loop"
              id="audio"
              preload="true"
            ></audio>
          </div>
          <div style="width:400px;height:64px;">
            <img
              style="width:100%"
              src="https://imgcdn.hemiao100.com/hemiaoBase/e0f29686-f763-431a-9716-4ef1cdbef1ae.png"
              alt=""
            />
          </div>
          <div class="turnTable" style="width:400px;height:600px">
            <div
              class="circle"
              :style="{
                background: 'url(' + gameBgp2 + ')',
                backgroundSize: '100%'
              }"
            >
              <section class="gb-wheel-container" id="gbWheel">
                <div
                  class="gb-wheel-content"
                  :style="{ transform: `rotate(${rotateDeg}deg)` }"
                >
                  >
                  <ul class="gb-wheel-line">
                    <li
                      v-for="(v, i) in rule.turntablePrizeRuleList"
                      class="gb-wheel-litem"
                      :key="i"
                      :style="{
                        transform: `rotate(${i * turnNum + turnNum / 2}turn)`
                      }"
                    >
                      >
                    </li>
                  </ul>
                  <div class="gb-wheel-list">
                    .
                    <div
                      class="gb-wheel-item"
                      v-for="(v, i) in rule.turntablePrizeRuleList"
                      :key="i"
                    >
                      <div
                        class="gb-wheel-icontent"
                        :style="{ transform: `rotate(${i * turnNum}turn)` }"
                      >
                        <p class="gb-wheel-money">
                          {{ v.rankingSeqNum }}
                        </p>
                        <p class="gb-wheel-itext" v-if="v.money !== '0'">
                          {{ v.prizeName }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  class="gb-wheel-btn pointer"
                  id="gbLottery"
                  :style="{
                    background: 'url(' + gameBgp3 + ')',
                    backgroundSize: '100%'
                  }"
                >
                  GO
                </button>
              </section>
            </div>
            <!-- <img
                class="pvwimg"
                style="width:100%;height:100%"
                :src="listHeaderImgUrl"
                alt=""
              /> -->
          </div>

          <div class="describes">
            <p>已有 {{ ruleForm.visualJoinNum }}人参与</p>
            <p v-if="rule.drawType == 'daily'">
              您今天还有 {{ rule.drawPrizeNumDaily }}次抽奖机会
            </p>
            <p v-else>您今天还有 {{ rule.drawPrizeNumTotal }}次抽奖机会</p>
          </div>
        </div>
      </div>
      <!-- </el-scrollbar> -->
      <my-upload
        field="file"
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="showPrizeImg"
        noCircle
        noSquare
        :width="100"
        :height="100"
        :headers="{ 'X-Access-Token': $token }"
        :params="{ fileDir: 'goodsCenter' }"
        :url="$uploadUrl"
        img-format="png"
      ></my-upload>
    </div>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor
  },
  data() {
    const patterndRawTypeFunc = function(rule, val, callback) {
      if (this.rule.drawType === "total") {
        if (
          this.rule.drawPrizeNumTotal &&
          this.rule.eachWinningUpperLimitTotal
        ) {
          callback();
        } else {
          return callback(new Error("请填写所有项"));
        }
      } else {
        if (
          this.rule.eachWinningUpperLimitDaily &&
          this.rule.drawPrizeNumDaily
        ) {
          callback();
        } else {
          return callback(new Error("请填写所有项"));
        }
      }
      callback();
    }.bind(this);
    const patterndEachConsumIntegralFunc = function(rule, val, callback) {
      if (!this.threshold.eachConsumIntegral) {
        return callback(new Error("请填写每次消耗积分"));
      }
      callback();
    }.bind(this);
    const patterndEstimatedNumFunc = function(rule, val, callback) {
      if (!this.rule.estimatedNum && this.rule.estimatedNum !== 0) {
        return callback(new Error("请填写预计参与次数"));
      }
      callback();
    }.bind(this);
    const patterndImgFunc = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请选择主图"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp2Func = function(rule, val, callback) {
      if (!this.gameBgp2) {
        return callback(new Error("请选择转盘图"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp3Func = function(rule, val, callback) {
      if (!this.gameBgp3) {
        return callback(new Error("请选择指针图"));
      }
      callback();
    }.bind(this);
    const patterndDrawTypeListFunc = (rule, val, callback) => {
      let flag = true;
      let winningRateTotal = 0;
      this.rule.turntablePrizeRuleList.map(v => {
        if (
          !v.rankingSeqNum ||
          !v.prizeType ||
          !v.typeValue ||
          !v.prizeName ||
          !v.prizeNum ||
          !v.eachPrizeWinningUpperLimit ||
          (!v.winningRate && v.winningRate != 0)
        ) {
          flag = false;
        }
        winningRateTotal += v.winningRate * 1;
      });
      if (flag) {
        if (winningRateTotal > 100) {
          return callback(new Error("中奖率合计不能超过100%!"));
        }
        callback();
      } else {
        return callback(new Error("请填写所有项"));
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      rotateDeg: 0,
      type: true,
      couponList: [],
      storeId: "",
      showPrizeImg: false,
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      showgameBgp2: false,
      showgameBgp3: false,
      dialogVisible: false,
      gameBgp2:
        "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%B5%84%E6%BA%90%201.png",
      gameBgp3:
        "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%BD%AC%E7%9B%98-06.png",
      listHeaderImgUrl:
        "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E6%9C%AA%E6%A0%87%E9%A2%98-1.png",
      gridBg:
        "https://imgcdn.hemiao100.com/hemiaoBase/hmService/wheelAct-gridBg.png",
      rollBg:
        "https://imgcdn.hemiao100.com/decoration/ps8cebd012a8481faf-8ef1-4501-9294-4b963ab597f7.png",
      rollCircleBg:
        "https://imgcdn.hemiao100.com/decoration/ps89dbc6bf3a87a4d5-e0ea-46f0-bd1b-67be1c617d2c.png",
      gridCircleBg:
        "https://imgcdn.hemiao100.com/decoration/ps824f88d97cc48044-c012-4cbd-8742-560cd616749c.png",
      rollPointerBg:
        "https://imgcdn.hemiao100.com/decoration/ps880204674c532487-4cd4-4d19-a6ab-6b006768935e.png",
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        },
        {
          id: "gameAstrict",
          name: "活动限制"
        }
      ],
      ruleForm: {
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgm: "",
        estimatedNum: "",
        visualJoinNum: "0",
        activityDate: []
      },
      rule: {
        uiType: "",
        estimatedNum: "",
        drawPrizeNumTotal: "",
        eachWinningUpperLimitTotal: "",
        drawPrizeNumDaily: "",
        eachWinningUpperLimitDaily: "",
        drawType: "total",
        turntablePrizeRuleList: [
          {
            rankingSeqNum: "",
            prizeType: "1",
            typeValue: "",
            prizeName: "",
            prizeNum: "",
            prizePriority: "",
            prizeImg: "",
            winningRate: "",
            awardThreshold: 0,
            eachPrizeWinningUpperLimit: "",
          }
        ]
      },
      threshold: {
        eachConsumIntegral: ""
      },
      rules: {
        visualJoinNum: [
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            message: "请输入虚拟参与人数",
            trigger: "blur"
          }
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" }
        ],
        activityDate: [
          {
            required: true,
            message: "请选择活动时间段",
            trigger: "blur"
          }
        ],
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patterndImgFunc,
            trigger: "blur"
          }
        ],
        gameBgp2: [
          {
            required: true,
            validator: patterndgameBgp2Func,
            trigger: "blur"
          }
        ],
        gameBgp3: [
          {
            required: true,
            validator: patterndgameBgp3Func,
            trigger: "blur"
          }
        ],
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur"
          }
        ],
        drawType: [
          {
            required: true,
            validator: patterndRawTypeFunc,
            trigger: "change"
          }
        ],
        drawTypeList: [
          {
            required: true,
            validator: patterndDrawTypeListFunc,
            trigger: "blur"
          }
        ],
        estimatedNum: [
          {
            required: true,
            validator: patterndEstimatedNumFunc,
            trigger: "blur"
          }
        ],
        eachConsumIntegral: [
          {
            required: true,
            validator: patterndEachConsumIntegralFunc,
            trigger: "blur"
          }
        ]
      },
      actDesc: {},
      isCollapse: true,
      wheelType: ""
    };
  },
  computed: {
    len() {
      return this.rule.turntablePrizeRuleList.length;
    },
    turnNum() {
      return 1 / this.len;
    }
  },
  watch: {},
  created() {
    this.wheelType = this.$route.query.wheelType;
    this.setWheelType(this.wheelType);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcHeight();
    const { type } = this.$route.query;
    this.type = !!type;

    this.activityDetail().then(res => {
      this.ruleForm.activityDate = [
        res.result.gameStartTime,
        res.result.gameEndTime
      ];
      this.listHeaderImgUrl = res.result.gameBgp;
      this.gameBgp2 = res.result.gameBgp2;
      this.gameBgp3 = res.result.gameBgp3;
      if (res.result.rule) {
        this.rule = res.result.rule;
        if (res.result.rule.drawType == "daily") {
          this.rule.drawPrizeNumDaily = this.rule.drawPrizeNum;
          this.rule.eachWinningUpperLimitDaily = this.rule.eachWinningUpperLimit;
          this.rule.drawPrizeNumTotal = "";
          this.rule.eachWinningUpperLimitTotal = "";
        } else {
          this.rule.drawPrizeNumTotal = this.rule.drawPrizeNum;
          this.rule.uiType = res.result.rule.uiType;
          this.wheelType = res.result.rule.uiType;
          this.rule.eachWinningUpperLimitTotal = this.rule.eachWinningUpperLimit;
        }
      }

      // this.rule.estimatedNum = res.result.rule.estimatedNum;

      for (let key in res.result) {
        this.ruleForm[key] = res.result[key];
      }
      let couponSendIds = [];
      res.result.rule.turntablePrizeRuleList.filter(v => {
        if (v.prizeType === "2") {
          couponSendIds.push(v.typeValue);
        }
      });
      this.$store
        .dispatch("findCouponSendByEvent", { couponSendIds })
        .then(res => {
          if (res.code === "0") {
            this.couponList = res.result;
          }
        });
      if (res.result.threshold) {
        this.threshold.eachConsumIntegral =
          res.result.threshold.eachConsumIntegral;
      }
    });
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    filterGt0OrFixed22(index, prop) {
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.rule.turntablePrizeRuleList[index][prop].indexOf(".") < 0 &&
        this.rule.turntablePrizeRuleList[index][prop] != ""
      ) {
        //首位是0的话去掉
        this.rule.turntablePrizeRuleList[index][prop] = parseFloat(
          this.rule.turntablePrizeRuleList[index][prop]
        );
      }
    },
    filterGt0OrFixed0(index, prop) {
      // this.rule.turntablePrizeRuleList[index][
      //   prop
      // ] = this.rule.turntablePrizeRuleList[index][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(/[^\d]/g, "");
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");

      this.rule.turntablePrizeRuleList[index][prop] = new Number(
        this.rule.turntablePrizeRuleList[index][prop]
      );
    },
    addGoodsImg(v, type) {
      this.uploadType = type;
      this.showPrizeImg = true;
      this.currentGoods = v;
    },
    setWheelType(type) {
      switch (type) {
        case "grid":
          this.listHeaderImgUrl = this.gridBg;
          this.gameBgp2 = this.gridCircleBg;
          break;
        case "roll":
          this.listHeaderImgUrl = this.rollBg;
          this.gameBgp2 = this.rollCircleBg;
          this.gameBgp3 = this.rollPointerBg;
          break;
        default:
          break;
      }
    },
    activityDetail() {
      const { gameId } = this.$route.query;
      const params = {
        gameId
      };
      return this.$store.dispatch("queryActivitDetail", params);
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.uploadType === "prizeImg") {
        this.currentGoods.prizeImg = jsonData.result;
        return;
      }
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    cropUploadSuccessBgp2(jsonData) {
      if (this.showgameBgp2) {
        this.gameBgp2 = jsonData.result;
      }
    },
    cropUploadSuccessBgp3(jsonData) {
      if (this.showgameBgp3) {
        this.gameBgp3 = jsonData.result;
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowgameBgp2() {
      this.showgameBgp2 = !this.showgameBgp2;
    },
    toggleShowgameBgp3() {
      this.showgameBgp3 = !this.showgameBgp3;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    addChild() {
      if (
        this.wheelType === "grid" &&
        this.rule.turntablePrizeRuleList.length >= 7
      ) {
        this.$message({
          message: "九宫格转盘只能添加7个商品",
          type: "warning"
        });
        return;
      }
      this.rule.turntablePrizeRuleList.push({
        rankingSeqNum: "",
        prizeType: "1",
        typeValue: "",
        prizeName: "",
        prizeNum: "",
        prizePriority: "",
        prizeImg: "",
        winningRate: "",
        awardThreshold: 0,
        eachPrizeWinningUpperLimit: "",
      });
    },
    filterGt0OrFixed(prop, i) {
      this.rule.turntablePrizeRuleList[i][
        prop
      ] = this.rule.turntablePrizeRuleList[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule.turntablePrizeRuleList[i][
        prop
      ] = this.rule.turntablePrizeRuleList[i][prop]
        .replace(".", "")
        .replace("-", "");

      this.rule.turntablePrizeRuleList[i][
        prop
      ] = this.rule.turntablePrizeRuleList[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed2(prop) {
      // this.rule[prop] = this.rule[prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule[prop] = this.rule[prop].replace(".", "").replace("-", "");

      this.rule[prop] = this.rule[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed3(prop) {
      // this.threshold[prop] = this.threshold[prop].replace(/^(0+)/, ""); //过滤0开头
      this.threshold[prop] = this.threshold[prop]
        .replace(".", "")
        .replace("-", "");

      this.threshold[prop] = this.threshold[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    deleteChild(index) {
      this.rule.turntablePrizeRuleList.splice(index, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          this.ruleForm.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          this.ruleForm.estimatedNum = new Number(this.ruleForm.estimatedNum);
          let params = this.ruleForm;
          params.gameType = "turntable";
          params.gameBgp = this.listHeaderImgUrl;
          if (this.rule.drawType == "daily") {
            this.rule.drawPrizeNum = this.rule.drawPrizeNumDaily;
            this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitDaily;
          } else {
            this.rule.drawPrizeNum = this.rule.drawPrizeNumTotal;
            this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitTotal;
          }
          if (!this.rule.uiType) {
            this.rule.uiType = this.$route.query.wheelType || "wheel";
          }
          params = Object.assign(params, {
            rule: this.rule,
            threshold: this.threshold,
            gameId: this.$route.query.gameId
          });

          this.$store.dispatch("editActivity", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleRemove(index) {
      this.$set(this.rule.turntablePrizeRuleList[index], "prizeImg", "");
    },
    handleRemoveGameBgp(){
      this.listHeaderImgUrl = "";
    },
    handleRemoveGameBgp2() {
      this.gameBgp2 = "";
    },
    handleRemoveBgp3() {
      this.gameBgp3 = "";
    },
    bgm() {
      let audio = document.querySelector("#audio");

      if (!this.isPlaying) {
        audio.play();
        this.isPlaying = true;
      } else {
        audio.pause();
        this.isPlaying = false;
      }
    },
    minimum() {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>
<style lang="scss" scoped>
.game-select {
  .el-select {
    width: 140px !important;
    .el-input {
      width: 140px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.act-container {
  // max-width: 2000px;
  overflow-x: auto;
  // transform: scale(1);
}
.fixed-but {
  position: fixed;
  top: 150px;
  right: 50px;
}
.gb-wheel-container ul,
.gb-wheel-container li,
.gb-wheel-container p {
  margin: 0;
  padding: 0;
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 130px;
    height: 130px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
// @keyframes rotate {
//   from {
//     transform: rotate(0);
//   }
//   to {
//     transform: rotate(1turn);
//   }
// }

.gb-wheel-container ul,
.gb-wheel-container li {
  list-style: none;
}

.gb-wheel-container {
  margin: 0 auto;
  position: relative;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  overflow: hidden;
}

.gb-wheel-content {
  position: absolute;
  left: 21px;
  top: 21px;
  z-index: 2;
  width: 280px;
  height: 280px;
  box-sizing: border-box;
  border-radius: inherit;
  // background-color: #ffcb3f;
  background-size: 12px 14px;
}

.gb-wheel-list {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.gb-wheel-item {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  color: #e4370e;
  font-weight: bold;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.6);
}

.gb-wheel-itext {
  font-size: 1.4rem;
  font-weight: lighter;
}

.gb-wheel-money [class*="icono-"] {
  color: #e4370e;
}

.gb-wheel-line {
  position: absolute;
  left: 0;
  top: 0;
  width: inherit;
  height: inherit;
  z-index: 99;
}

.gb-wheel-litem {
  position: absolute;
  left: 130px;
  top: 0;
  width: 1px;
  height: 130px;
  background-color: rgba(228, 55, 14, 0.6);
  overflow: hidden;
  transform-origin: 50% 130px;
}

.gb-wheel-icontent {
  position: relative;
  display: block;
  padding-top: 1.5rem;
  margin: 0 auto;
  text-align: center;
  transform-origin: 50% 130px;
  p {
    color: #e4370e;
    font-size: 10px;
  }
}
.gb-wheel-btn {
  z-index: 400;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 90px;
  line-height: 104px;
  width: 71px;
  color: #fff;
  text-align: center;
  //background: url("https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%BD%AC%E7%9B%98-06.png");
  background-size: 100%;
  background-repeat: no-repeat;
  border: none;
  font-size: 20px;
}
.gb-wheel-btn::before {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  content: "";
  width: 30px;
  height: 30px;
  background: url("https://imgcdn.hemiao100.com/hemiaoBase/51ac05aa-2baf-4a29-9818-7de032442404.png");
  background-size: 100% 100%;
}

a.gb-wheel-btn {
  border-bottom: none;
}

.gb-wheel-btn.disabled,
.gb-wheel-btn.disabled::after {
  pointer-events: none;
  background: #b07a7b;
  color: #ccc;
}
.turnTable {
  position: relative;
  height: 420px;
  margin: 4rem auto 10px;
  .circle {
    position: absolute;
    height: 320px;
    width: 320px;
    z-index: 20;
    //background: url("https://imgcdn.hemiao100.com/hemiaoBase/f94fbd59-37dc-4a9d-9c9f-371fb3e3f465.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 50%;
    box-shadow: 0px 0px 8px 6px rgba(0, 0, 0, 0.1);
  }
  .pedestal {
    position: absolute;
    bottom: 0;
    width: 320px;
    height: 160px;
    margin: 0 auto;
    background: url("https://imgcdn.hemiao100.com/hemiaoBase/5e03a2c5-657b-4307-b5dc-b1628ecca7c2.png");
    background-size: 100% 100%;
    left: 50%;
    transform: translateX(-50%);
  }

  .btn {
    font-size: 10px;
    background: #fddb00;
    color: #ff363e;
    box-shadow: 0px 0px 8px 1px rgba(239, 33, 6, 0.1) inset;
    border: 1px solid transparent;
    border-radius: 30px;
    padding: 7.5px 10px;
  }
  .prize {
    margin-left: 3rem;
  }
  .rule {
    margin-right: 3rem;
  }
}
.pvw {
  .pvws {
    width: 400px;
    height: 667px;
    margin-right: 100px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    position: fixed;
    right: 0;
    // .pvwimg {
    //   position: relative;
    // }
    .describes {
      width: 100%;
      position: absolute;
      left: 50%;
      margin-left: -50%;
      bottom: 35px;
      font-size: 18px;
      font-weight: 600;
      color: #fffc78;
      p {
        text-align: center;
      }
    }
  }
  #audio_btn {
    position: absolute;
    left: 10px;
    top: 70px;
    z-index: 999999;
    width: 45px;
    height: 45px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
    background-size: contain;
    background-repeat: no-repeat;
  }
  // .rotate {
  //   -webkit-animation: rotating 1.2s linear infinite;
  //   -moz-animation: rotating 1.2s linear infinite;
  //   -o-animation: rotating 1.2s linear infinite;
  //   animation: rotating 1.2s linear infinite;
  // }
}
.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
.priview {
  position: relative;
  width: 400px;
  height: 667px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp2 {
  position: relative;
  width: 400px;
  height: 400px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp3 {
  position: relative;
  width: 150px;
  height: 161px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}
.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}
.priviews {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
